'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTACT = exports.FREE = exports.EXHIBITORS = exports.HEADERS = exports.MAPS = exports.WORKSHOPS = exports.CUSTOM = exports.FOOTER = exports.NAVBAR = exports.SPONSORS = exports.SPEAKERS = exports.COOKIE_CONSENT = exports.B2B_MATCHMAKING = exports.REGISTRATION_TYPES = exports.NETWORKING_LOGIN = exports.REGISTRATION = undefined;
var _BlockTypes;
var _site = require('../actions/site');
var _navbar = require('../assets/icons/navbar.svg');
var _navbar2 = _interopRequireDefault(_navbar);
var _header = require('../assets/icons/header.svg');
var _header2 = _interopRequireDefault(_header);
var _footer = require('../assets/icons/footer.svg');
var _footer2 = _interopRequireDefault(_footer);
var _workshops = require('../assets/icons/workshops.svg');
var _workshops2 = _interopRequireDefault(_workshops);
var _registration = require('../assets/icons/registration.svg');
var _registration2 = _interopRequireDefault(_registration);
var _custom = require('../assets/icons/custom.svg');
var _custom2 = _interopRequireDefault(_custom);
var _speakers = require('../assets/icons/speakers.svg');
var _speakers2 = _interopRequireDefault(_speakers);
var _sponsors = require('../assets/icons/sponsors.svg');
var _sponsors2 = _interopRequireDefault(_sponsors);
var _attendees = require('../assets/icons/attendees.svg');
var _attendees2 = _interopRequireDefault(_attendees);
var _maps = require('../assets/icons/maps.svg');
var _maps2 = _interopRequireDefault(_maps);
var _login = require('../assets/icons/login.svg');
var _login2 = _interopRequireDefault(_login);
var _code = require('../assets/icons/code.svg');
var _code2 = _interopRequireDefault(_code);
var _contact = require('../assets/icons/contact.svg');
var _contact2 = _interopRequireDefault(_contact);
var _participants = require('../assets/icons/participants.svg');
var _participants2 = _interopRequireDefault(_participants);
var _cookies = require('../assets/icons/cookies.svg');
var _cookies2 = _interopRequireDefault(_cookies);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var REGISTRATION = exports.REGISTRATION = 'REGISTRATION',
  NETWORKING_LOGIN = exports.NETWORKING_LOGIN = 'NETWORKING_LOGIN',
  REGISTRATION_TYPES = exports.REGISTRATION_TYPES = 'REGISTRATION_TYPES',
  B2B_MATCHMAKING = exports.B2B_MATCHMAKING = 'B2B_MATCHMAKING',
  COOKIE_CONSENT = exports.COOKIE_CONSENT = 'COOKIE_CONSENT',
  // ATTENDEES = 'ATTENDEES',
  SPEAKERS = exports.SPEAKERS = 'SPEAKERS',
  SPONSORS = exports.SPONSORS = 'SPONSORS',
  NAVBAR = exports.NAVBAR = 'NAVBAR',
  FOOTER = exports.FOOTER = 'FOOTER',
  CUSTOM = exports.CUSTOM = 'CUSTOM',
  WORKSHOPS = exports.WORKSHOPS = 'WORKSHOPS',
  MAPS = exports.MAPS = 'MAPS',
  HEADERS = exports.HEADERS = 'HEADERS',
  EXHIBITORS = exports.EXHIBITORS = 'EXHIBITORS',
  FREE = exports.FREE = 'FREE',
  CONTACT = exports.CONTACT = 'CONTACT';
var BlockTypes = (_BlockTypes = {}, _defineProperty(_BlockTypes, REGISTRATION, {
  id: REGISTRATION,
  name: 'Registration',
  icon: _registration2.default
}), _defineProperty(_BlockTypes, NETWORKING_LOGIN, {
  id: NETWORKING_LOGIN,
  name: 'Networking Login',
  icon: _login2.default
}), _defineProperty(_BlockTypes, REGISTRATION_TYPES, {
  id: REGISTRATION_TYPES,
  name: 'Registration types',
  icon: _registration2.default
}), _defineProperty(_BlockTypes, B2B_MATCHMAKING, {
  id: B2B_MATCHMAKING,
  name: 'B2B Matchmaking',
  icon: _participants2.default,
  //fetchPage: fetchParticipants,
  initCompleteFetchs: [_site.fetchParticipantTypes]
}), _defineProperty(_BlockTypes, SPEAKERS, {
  id: SPEAKERS,
  name: 'Speakers',
  icon: _speakers2.default,
  fetchPage: _site.fetchSpeakers
}), _defineProperty(_BlockTypes, SPONSORS, {
  id: SPONSORS,
  name: 'Sponsors',
  icon: _sponsors2.default,
  fetchPage: _site.fetchSponsors
}), _defineProperty(_BlockTypes, WORKSHOPS, {
  id: WORKSHOPS,
  name: 'Activities',
  icon: _workshops2.default,
  fetchPage: _site.fetchWorkshops
}), _defineProperty(_BlockTypes, NAVBAR, {
  id: NAVBAR,
  name: 'Navbars',
  icon: _navbar2.default
}), _defineProperty(_BlockTypes, FOOTER, {
  id: FOOTER,
  name: 'Footers',
  icon: _footer2.default
}), _defineProperty(_BlockTypes, COOKIE_CONSENT, {
  id: COOKIE_CONSENT,
  name: 'Cookie Consent',
  icon: _cookies2.default
}), _defineProperty(_BlockTypes, HEADERS, {
  id: HEADERS,
  name: 'Headers',
  icon: _header2.default
}), _defineProperty(_BlockTypes, CUSTOM, {
  id: CUSTOM,
  name: 'Custom',
  icon: _custom2.default
}), _defineProperty(_BlockTypes, MAPS, {
  id: MAPS,
  name: 'Maps',
  icon: _maps2.default,
  fetchPage: _site.fetchPois
}), _defineProperty(_BlockTypes, EXHIBITORS, {
  id: EXHIBITORS,
  name: 'Exhibitors',
  icon: _attendees2.default,
  fetchPage: _site.fetchExhibitors,
  initCompleteFetchs: [_site.fetchStandCategories, _site.fetchZones]
}), _defineProperty(_BlockTypes, FREE, {
  id: FREE,
  name: 'Free block',
  icon: _code2.default
}), _defineProperty(_BlockTypes, CONTACT, {
  id: CONTACT,
  name: 'Contact form',
  icon: _contact2.default
}), _BlockTypes);
exports.default = BlockTypes;